import { useStaticData } from '@mc/static-data-react'
import type { FreeTrial } from '@mc/api'

export const useGuestPass = () => {
  const { guestPass } = useStaticData<{
    guestPass?: FreeTrial
  }>()
  return guestPass
}
